module.exports = __webpack_public_path__ + "img/aneuflow.a435dab4.png";